import { Observable } from 'rxjs';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';

import { AppComfirmComponent } from './app-confirm.component';
import { AppComfirmLogoutComponent } from './app-confirm-logout.component';
interface confirmData {
  title?: string,
  message?: string,
  info?: string
}

@Injectable()
export class AppConfirmService {

  constructor(private dialog: MatDialog) { }

  public confirm(data:confirmData = {}): Observable<boolean> {
    data.title = data.title || 'Confirm';
    data.message = data.message || 'Are you sure?';
    let dialogRef: MatDialogRef<AppComfirmComponent>;
    dialogRef = this.dialog.open(AppComfirmComponent, {
      width: '380px',
      disableClose: true,
      data: {title: data.title, message: data.message}
    });
    return dialogRef.afterClosed();
  }
  public logout(data: confirmData = {}): Observable<boolean> {
    data.title = data.title || 'Confirm';
    let dialogRef: MatDialogRef<AppComfirmLogoutComponent>;
    dialogRef = this.dialog.open(AppComfirmLogoutComponent, {
      width: '380px',
      disableClose: true,
      data: {title: data.title, message: data.message, info: data.info}
    });
    return dialogRef.afterClosed();
  }
 
}